import * as AccountStore from '../../store/AccountStore';
import * as GuideStore from '../../store/GuideStore';
import * as React from 'react';
import * as UserStore from '../../store/UserStore';
import * as signalR from "@microsoft/signalr";
import * as PhoneParser from 'libphonenumber-js/max'
import validator from 'validator';
import { Loader, Spinner } from '../components/Loader';
import { RouteComponentProps, withRouter } from 'react-router';
import AccountSelector from '../components/AccountSelector';
import { ApiUrls } from '../../constants/apiUrls';
import { ApplicationState } from '../../store';
import { ClientProcessingService } from '../../models/ServiceModels';
import Cookies from '../../support/Cookie';
import Input from '../components/Input';
import { Modal } from '../components/Modals';
import Navigation from '../../constants/enums/NavigationEnum';
import OneboardPage from '../pages/OneboardPage';
import { connect } from 'react-redux';
import { isSafari } from 'react-device-detect';

const dispatchAction = {
    ...AccountStore.actionCreators,
    ...GuideStore.actionCreators
}

type MainContentProps =
    AccountStore.AccountStateState &
    GuideStore.GuideState &
    {
        userState: UserStore.UserState
    } &
    typeof dispatchAction &
    RouteComponentProps<{}>;

interface MainContentState {
    oneboardIsOpen: boolean,
    inProgress: boolean,
    phone: string,
    firstName: string,
    secondName: string,
    thirdName: string,
    hubConnection: signalR.HubConnection | null;
}

const _cookie = new Cookies();

class MainContent extends React.PureComponent<MainContentProps, MainContentState> {

    constructor(props: MainContentProps) {
        super(props);

        let oneboardIsOpen = _cookie.GetOneboardKey() === "true";
        this.state = {
            oneboardIsOpen: oneboardIsOpen,
            phone: "",// this.props.user?.profile.personalCabinetRegisterPhoneUser !== undefined ? this.props.user?.profile.personalCabinetRegisterPhoneUser : "",
            firstName: "",
            secondName: "",
            thirdName: "",
            inProgress: false,
            hubConnection: null
        };
    }

    Oneboard_onClose() {
        _cookie.SetOneboardKey(false);
        this.setState({ oneboardIsOpen: false })
    }

    async componentDidMount() {
        await this.props.InitAccountStateAction();
        await this.props.InitGuideAction();

        if (this.props.isLoading === false) {
            await this.props.GetAccountsStateAction();
        }

        if (this.props.guideIsLoad === false)
            await this.props.GetGuideStateAction();

        await this.ConnectHub();


    }

    private async ContactAdd_onClick() {
        this.setState({ inProgress: true });
        if (!this.state.inProgress && this.DataCheck()) {
            await this.props.CreateMainContactAction({
                firstName: this.state.firstName,
                middleName: this.state.thirdName,
                lastName: this.state.secondName,
                mainContact: this.state.phone,
            })
        }
        this.setState({ inProgress: false });
    }

    private DataCheck() {
        let phone = PhoneParser.parsePhoneNumberFromString(this.state.phone || '', "RU");
        return !validator.isEmpty(this.state.firstName || '') && !validator.isEmpty(this.state.secondName || '') && phone?.isValid() === true

    }

    private async ConnectHub() {
        if (this.state.hubConnection === null) {
            let hubConnection = new signalR.HubConnectionBuilder()
                .withUrl(ApiUrls.ProcessingServiceChangeHub,
                    { accessTokenFactory: () => this.props.userState.user?.access_token || '', withCredentials: false })
                .configureLogging(signalR.LogLevel.None)
                .build();

            hubConnection.start().then(a => {

                this.setState({
                    hubConnection: hubConnection
                });
                hubConnection.onclose((error) => {

                    if (error) {
                        setTimeout(() => { this.Reconnect() }, 30000)
                    }

                })
                hubConnection.on("ChangeStatusProcessingService", (processingService: ClientProcessingService) => {

                    this.props.MobileServiceStatusUpdateAction(processingService)  //Событие изменения статуса
                });

            })
                .catch(error => {

                });

        }
    }

    private Reconnect() {
        if (this.state.hubConnection) {
            this.state.hubConnection.start().catch(() => {
                setTimeout(() => { this.Reconnect() }, 30000)
            });
        }
    }



    public render() {
 
        return (
            <>
                {!this.props.isLoading
                    ? <Loader /> :
                    <>
                        <Modal isOpen={!this.props.isExistsMainContact} onClose={() => { }}>
                            <div className='contacts'>
                                <div className='text-bold'>Добавление контактов</div>
                                <div className='name-passive--8'>Добро пожаловать в личный кабинет Цифрал-Сервис! Для продолжения вам необходимо заполнить контактные данные, которые необходимы для создания заявок.</div>
                                <div className='contacts__inputs'>
                                    <Input type='tel' onChange={(value) => this.setState({ phone: value })} placeholder='Номер телефона' />
                                    <Input type='string' onChange={(value) => this.setState({ secondName: value })} placeholder='Фамилия' />
                                    <Input type='string' onChange={(value) => this.setState({ firstName: value })} placeholder='Имя' />
                                    <Input type='string' onChange={(value) => this.setState({ thirdName: value })} placeholder='Отчество' />
                                </div>
                                <div className={`contacts__button button button-text ${!this.DataCheck() && "disabled"}`}

                                    onClick={() => !this.state.inProgress && this.ContactAdd_onClick()}>
                                    {this.state.inProgress ? <Spinner /> : "Добавить"}

                                </div>
                            </div>
                        </Modal>
                        {this.state.oneboardIsOpen && <OneboardPage oneboard_onClose={() => this.Oneboard_onClose()} />}
                        <div className='main' style={{
                            paddingBottom: this.props.location.pathname.toLocaleLowerCase() !== Navigation.SubscriptionPage.toLocaleLowerCase() ? "" : "0",
                            marginBottom: isSafari ? "0px" : ""
                        }}>
                            {this.props.location.pathname.toLocaleLowerCase() !== Navigation.SubscriptionPage.toLocaleLowerCase() && <AccountSelector />}
                            {this.props.children}
                        </div>
                    </>
                }
            </>
        );
    }
}


export default connect(
    (state: ApplicationState) => ({ ...state.AccountState, ...state.guide, userState: state.user }),
    dispatchAction
)(withRouter(MainContent) as any);